import { Activity, Location, Session } from '@efacity/common';
import { apiService } from './apiService';
import { OrganizationInformation } from '@efacity/react-next-sc';

export interface LocationsForEnrichmentActivityResponse {
  activity: Activity;
  locations: Location[];
  orgInfo: OrganizationInformation;
}

export const locationsForEnrichmentActivityFetcher = (orgId: string, activityId: string) => {
  return apiService.get<LocationsForEnrichmentActivityResponse>(`/org/${orgId}/activity/enrichment/${activityId}`);
};

export interface AgreementDisplayValues {
  name: string;
  richText: string;
}
export interface SessionsForEnrichmentActivityResponse {
  activity: Activity;
  sessions: Session[];
  orgInfo: OrganizationInformation;
  agreements: AgreementDisplayValues[];
  location: Location;
  message?: string;
}

export const sessionsForEnrichmentActivityFetcher = (orgId: string, activityId: string, locationId: string) => {
  return apiService.get<SessionsForEnrichmentActivityResponse>(
    `/org/${orgId}/activity/enrichment/${activityId}/locations/${locationId}`
  );
};
